/* # =================================================================
# sweatAlert2
#data-alert=trueで動作
＃ data-title ががconfirmのaタグに
# ================================================================= */
import Swal from 'sweetalert2';

export default function alertSwalNoWanted() {
	const hasAlertLinks = document.querySelectorAll('[data-nowanted="true"]');
	hasAlertLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const titleMessage = `現在募集中の大会はありません`;
			const message = '募集開始まで今しばらくお待ちください';
			Swal.fire({
				title: titleMessage,
				html: message,
				icon: 'info',
				confirmButtonText: 'OK',
				confirmButtonColor: '#A0070D',
			});
		});
	});
}
